import { api } from "./api";

export interface QRProfile {
  id: number;
  farm_id: number;
  code: string;
  title: string;
  description: string;
  qr_base_url: string;
  qr_image_url?: string;
  attachment_count: number;
  created_at: string;
  updated_at: string;
}

export const qrProfileService = {
  getOrCreate: (): Promise<QRProfile> =>
    api.get<QRProfile>("/qr-profiles").then((r) => r.data),

  update: (
    id: number,
    data: { title: string; description?: string; code?: string; qr_base_url?: string; qr_image_key?: string }
  ): Promise<QRProfile> =>
    api.put<QRProfile>(`/qr-profiles/${id}`, data).then((r) => r.data),

  qrCodeURL: (id: number): string =>
    `${api.defaults.baseURL}/qr-profiles/${id}/qr`,
};
